import PropTypes from 'prop-types';

import { buildImagePath } from '../../../JobComponents/Company/Image/logo';

const badgeImagePropType = PropTypes.exact({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
});

const badgePropType = PropTypes.exact({
    image: badgeImagePropType,
    text: PropTypes.string,
});

export const convincerPropType = PropTypes.exact({
    text: PropTypes.string.isRequired,
    badge: badgePropType.isRequired,
    v2: PropTypes.shape({
        layout: PropTypes.string,
        svg: PropTypes.string,
        text: PropTypes.string,
    }),
});

const badgeTransforms = {
    icon: 'c_scale,ar_22:15,w_44,dpr_auto,q_auto,f_auto,fl_lossy',
    jobCardIcon: 'c_scale,w_48,h_44,dpr_auto,q_auto,f_auto,fl_lossy',
};

export const buildBadgeIconSrc = (id) =>
    buildImagePath(id, 'icon', badgeTransforms);
export const buildShortConvincerBadgeSrc = (id) =>
    buildImagePath(id, 'jobCardIcon', badgeTransforms);
